exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-item-point-dialog .photo-holder {\n  position: relative;\n  width: 390px;\n  margin-bottom: 15px;\n}\nfi-item-point-dialog .photo-holder img {\n  max-width: 100%;\n  height: auto;\n}\nfi-item-point-dialog .photo-holder button {\n  visibility: hidden;\n  margin: 0;\n  right: 0;\n  top: 5px;\n  position: absolute;\n}\nfi-item-point-dialog .photo-holder:hover img {\n  opacity: 0.3;\n  -webkit-transition: all 0.1s ease-in-out;\n  -moz-transition: all 0.1s ease-in-out;\n  -o-transition: all 0.1s ease-in-out;\n  transition: all 0.1s ease-in-out;\n}\nfi-item-point-dialog .photo-holder:hover button {\n  visibility: visible;\n}", ""]);

// exports
